import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../../UrlHelper/baseUrl";
import Loader from "../../components/Loader";
import { Button, Dialog, DialogTitle, DialogContent } from "@mui/material";

const UserOrder = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  
  // Modal states
  const [openModal, setOpenModal] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  
  // Products state to store all products
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const userId = localStorage.getItem("userId");

    if (!userId) {
      setError("Please login to view your orders.");
      setLoading(false);
      return;
    }

    // Fetch all products first
    const fetchProducts = async () => {
      try {
        const productsRes = await axios.get(`${baseUrl}/products`);
        if (productsRes.data && productsRes.data.success) {
          setProducts(productsRes.data.products);
        }
      } catch (err) {
        console.error("Error fetching products:", err);
      }
    };

    // Then fetch user orders
    const fetchOrders = async () => {
      try {
        const res = await axios.get(`${baseUrl}/transactions`, {
          params: { userId },
        });

        const data = res.data;
        setOrders(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error(err);
        setError("Unable to load your orders. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
    fetchOrders();
  }, []);

  // Function to get product details by ID
  const getProductById = (productId) => {
    return products.find(product => product._id === productId);
  };

  // Function to check order status
  const checkOrderStatus = async (merchantOrderId, order) => {
    try {
      const tokenRes = await axios.get(`${baseUrl}/get-token`);
      const accessToken = tokenRes.data.access_token;

      const { data } = await axios.post(`${baseUrl}/checkOrderStatus`, {
        accessToken,
        merchantOrderId,
      });

      setOrderDetails({
        merchantOrderId,
        status: data.state,
        amount: data.amount,
        transactionId: data.paymentDetails?.[0]?.transactionId || "N/A",
        paymentMode: data.paymentDetails?.[0]?.paymentMode || "N/A",
        totalPrice: order?.totalPrice || "N/A",
        country: order?.country || "N/A",
        address: order?.address || "N/A",
        raw: JSON.stringify(data, null, 2),
      });

      setOpenModal(true);
    } catch (error) {
      alert(error.response?.data?.error || "Failed to check order status");
    }
  };

  if (loading) return <Loader />;

  if (error)
    return (
      <p style={{ color: "#e7671a", textAlign: "center", marginTop: "50px" }}>
        {error}
      </p>
    );

  if (orders.length === 0)
    return (
      <p style={{ color: "#e7671a", textAlign: "center", marginTop: "50px" }}>
        You have no orders yet.
      </p>
    );

  return (
    <div style={{ padding: "20px", maxWidth: "900px", margin: "0 auto" }}>
      <h2
        style={{
          color: "#e7671a",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        My Orders
      </h2>

      {orders.map((order) => {
        // Extract merchantOrderId from the Payments array
        const merchantOrderId = order.Payments && order.Payments.length > 0 
          ? order.Payments[0].merchantOrderId 
          : "N/A";
        
        // Extract payment status from the Payments array
        const paymentStatus = order.Payments && order.Payments.length > 0 
          ? order.Payments[0].paymentStatus 
          : "N/A";

        return (
          <div
            key={order._id}
            style={{
              border: "1px solid #e7671a",
              borderRadius: "12px",
              padding: "20px",
              marginBottom: "20px",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
              backgroundColor: "#fff",
              transition: "transform 0.2s",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
                marginBottom: "10px",
              }}
            >
              <div style={{ fontWeight: "bold", fontSize: "16px" }}>
                Order ID: {order._id}
              </div>
              <div style={{ fontStyle: "italic", color: "#555" }}>
                {new Date(order.createdAt).toLocaleDateString()}
              </div>
            </div>

            <div
              style={{
                marginBottom: "15px",
                padding: "10px",
                backgroundColor: "#f9f9f9",
                borderRadius: "8px",
              }}
            >
              <div>
                <strong>Name:</strong> {order.name}
              </div>
              <div>
                <strong>Mobile:</strong> {order.phoneNumber}
              </div>
              <div>
                <strong>Address:</strong> {order.address}, {order.city},{" "}
                {order.country} - {order.postCode}
              </div>
            </div>

            <div style={{ marginBottom: "10px" }}>
              <strong>Pooja Name:</strong>
              <ul style={{ listStyle: "none", padding: 0, marginTop: "5px" }}>
                {order.orders.map((item) => {
                  const product = getProductById(item.productId);
                  return (
                    <li
                      key={item._id}
                      style={{
                        borderBottom: "1px solid #eee",
                        padding: "8px 0",
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "14px",
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: "bold" }}>
                          {product ? product.name : "Product Not Found"}
                        </div>
                     
                      </div>
                      <div style={{ textAlign: "right" }}>
                       
                        <div style={{ fontWeight: "bold", color: "#e7671a" }}>
                          ₹ {product ? product.price : item.price}
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div
              style={{
                marginTop: "10px",
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              Total Amount: ₹{order.totalPrice}
            </div>

            {/* View Button */}
            <div style={{ marginTop: "15px", textAlign: "right" }}>
              <Button
                onClick={() => checkOrderStatus(merchantOrderId, order)}
                variant="outlined"
                color="primary"
                size="small"
                disabled={merchantOrderId === "N/A"}
              >
                View Details
              </Button>
            </div>
          </div>
        );
      })}

      {/* Modal for Order Status */}
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Order Status Details</DialogTitle>
        <DialogContent>
          {orderDetails ? (
            <div>
              <p>
                <strong>Merchant Order ID:</strong>{" "}
                {orderDetails.merchantOrderId}
              </p>
              <p>
                <strong>Status:</strong> {orderDetails.status}
              </p>
              <p>
                <strong>Total Price:</strong> ₹{orderDetails.totalPrice}
              </p>
              <p>
                <strong>Country:</strong> {orderDetails.country}
              </p>
              <p>
                <strong>Address:</strong> {orderDetails.address}
              </p>
              {orderDetails.transactionId !== "N/A" && (
                <p>
                  <strong>Transaction ID:</strong> {orderDetails.transactionId}
                </p>
              )}
              {orderDetails.paymentMode !== "N/A" && (
                <p>
                  <strong>Payment Mode:</strong> {orderDetails.paymentMode}
                </p>
              )}
            </div>
          ) : (
            <p>Loading details...</p>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default UserOrder;